import { h } from "./../../../utils/createElement";
import { __assign, __extends } from "tslib";
import * as React from 'react';
import classNames from 'classnames';
import PickerMixin from './PickerMixin';
import { i18n } from '../../../common/locale';
var ITEM_HEIGHT = 36;
var indicatorTextMap = {
    year: i18n('yearPostfix'),
    month: i18n('monthPostfix'),
    day: i18n('dayPostfix'),
    hours: i18n('hourPosfix'),
    minutes: i18n('minutePostfix'),
    seconds: i18n('secondPostfix'),
    ampm: ''
};
var placeholderTextMap = {
    year: '2222',
    month: '12',
    day: '29',
    hours: '23',
    minutes: '59',
    seconds: '00',
    ampm: 'pm',
};
var Picker = (function (_super) {
    __extends(Picker, _super);
    function Picker(props) {
        var _this = _super.call(this, props) || this;
        _this.scrollHanders = (function () {
            var scrollY = -1;
            var lastY = 0;
            var startY = 0;
            var scrollDisabled = false;
            var isMoving = false;
            var setTransform = function (nodeStyle, value) {
                nodeStyle.transform = value;
                nodeStyle.webkitTransform = value;
            };
            var setTransition = function (nodeStyle, value) {
                nodeStyle.transition = value;
                nodeStyle.webkitTransition = value;
            };
            var scrollTo = function (_x, y, time) {
                if (time === void 0) { time = 0.3; }
                if (scrollY !== y) {
                    scrollY = y;
                    if (time && !_this.props.noAnimate) {
                        setTransition(_this.contentRef.style, "cubic-bezier(0,0,0.2,1.15) " + time + "s");
                    }
                    setTransform(_this.contentRef.style, "translate3d(0," + -y + "px,0)");
                    setTimeout(function () {
                        _this.scrollingComplete();
                        if (_this.contentRef) {
                            setTransition(_this.contentRef.style, '');
                        }
                    }, Number(time) * 1000);
                }
            };
            var Velocity = (function (minInterval, maxInterval) {
                if (minInterval === void 0) { minInterval = 30; }
                if (maxInterval === void 0) { maxInterval = 100; }
                var _time = 0;
                var _y = 0;
                var _velocity = 0;
                var recorder = {
                    record: function (y) {
                        var now = Number(new Date());
                        _velocity = (y - _y) / (now - _time);
                        if (now - _time >= minInterval) {
                            _velocity = now - _time <= maxInterval ? _velocity : 0;
                            _y = y;
                            _time = now;
                        }
                    },
                    getVelocity: function (y) {
                        if (y !== _y) {
                            recorder.record(y);
                        }
                        return _velocity;
                    },
                };
                return recorder;
            })();
            var onFinish = function () {
                isMoving = false;
                var targetY = scrollY;
                var height = (_this.props.children.length - 1) * ITEM_HEIGHT;
                var time = 0.3;
                var velocity = Velocity.getVelocity(targetY) * 4;
                if (velocity) {
                    targetY = velocity * 40 + targetY;
                    time = Math.abs(velocity) * 0.1;
                }
                if (targetY % ITEM_HEIGHT !== 0) {
                    targetY = Math.round(targetY / ITEM_HEIGHT) * ITEM_HEIGHT;
                }
                if (targetY < 0) {
                    targetY = 0;
                }
                else if (targetY > height) {
                    targetY = height;
                }
                scrollTo(0, targetY, time < 0.3 ? 0.3 : time);
                _this.onScrollChange();
            };
            var onStart = function (y) {
                if (scrollDisabled) {
                    return;
                }
                isMoving = true;
                startY = y;
                lastY = scrollY;
            };
            var onMove = function (y) {
                if (scrollDisabled || !isMoving) {
                    return;
                }
                scrollY = lastY - y + startY;
                Velocity.record(scrollY);
                _this.onScrollChange();
                setTransform(_this.contentRef.style, "translate3d(0," + -scrollY + "px,0)");
            };
            return {
                touchstart: function (evt) { return onStart(evt.touches[0].pageY); },
                mousedown: function (evt) { return onStart(evt.pageY); },
                touchmove: function (evt) {
                    evt.preventDefault();
                    onMove(evt.touches[0].pageY);
                },
                mousemove: function (evt) {
                    evt.preventDefault();
                    onMove(evt.pageY);
                },
                touchend: function () { return onFinish(); },
                touchcancel: function () { return onFinish(); },
                mouseup: function () { return onFinish(); },
                getValue: function () {
                    return scrollY;
                },
                scrollTo: scrollTo,
                setDisabled: function (disabled) {
                    if (disabled === void 0) { disabled = false; }
                    scrollDisabled = disabled;
                },
            };
        })();
        _this.scrollTo = function (top) {
            _this.scrollHanders.scrollTo(0, top);
        };
        _this.scrollToWithoutAnimation = function (top) {
            _this.scrollHanders.scrollTo(0, top, 0);
        };
        _this.fireValueChange = function (selectedValue) {
            if (selectedValue !== _this.state.selectedValue) {
                if (!('selectedValue' in _this.props)) {
                    _this.setState({
                        selectedValue: selectedValue,
                    });
                }
                if (_this.props.onValueChange) {
                    _this.props.onValueChange(selectedValue);
                }
            }
        };
        _this.onScrollChange = function () {
            var _a, _b;
            var top = _this.scrollHanders.getValue();
            if (top < 0) {
                return;
            }
            var children = React.Children.toArray(_this.props.children);
            var index = _this.props.computeChildIndex(top, ITEM_HEIGHT, children.length);
            if (_this.scrollValue === index) {
                return;
            }
            _this.scrollValue = index;
            var child = children[index];
            if (child) {
                var value = child.props.value;
                (_b = (_a = _this.props).onScrollChange) === null || _b === void 0 ? void 0 : _b.call(_a, value);
            }
            else if (!child && console.warn) {
                console.warn('child not found', children, index);
            }
        };
        _this.scrollingComplete = function () {
            var top = _this.scrollHanders.getValue();
            if (top >= 0) {
                _this.props.doScrollingComplete(top, ITEM_HEIGHT, _this.fireValueChange);
            }
        };
        var selectedValueState;
        var _a = _this.props, selectedValue = _a.selectedValue, defaultSelectedValue = _a.defaultSelectedValue;
        if (selectedValue !== undefined) {
            selectedValueState = selectedValue;
        }
        else if (defaultSelectedValue !== undefined) {
            selectedValueState = defaultSelectedValue;
        }
        else {
            var children = React.Children.toArray(_this.props.children);
            selectedValueState = children && children[0] && children[0].props.value;
        }
        _this.state = {
            selectedValue: selectedValueState,
        };
        return _this;
    }
    Picker.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this, contentRef = _a.contentRef, maskRef = _a.maskRef, rootRef = _a.rootRef;
        var rootHeight = Math.round(rootRef.getBoundingClientRect().height);
        var num = Math.floor(rootHeight / ITEM_HEIGHT);
        if (num % 2 === 0) {
            num--;
        }
        num--;
        num /= 2;
        contentRef.style.paddingTop = contentRef.style.paddingBottom = ITEM_HEIGHT * num + "px";
        maskRef.style.backgroundSize = "100% " + ITEM_HEIGHT * num + "px";
        this.scrollHanders.setDisabled(this.props.disabled);
        this.props.select(this.state.selectedValue, ITEM_HEIGHT, this.scrollTo);
        var passiveSupported = this.passiveSupported();
        var willPreventDefault = passiveSupported ? { passive: false } : false;
        var willNotPreventDefault = passiveSupported ? { passive: true } : false;
        Object.keys(this.scrollHanders).forEach(function (key) {
            if (key.indexOf('touch') === 0 || key.indexOf('mouse') === 0) {
                var pd = key.indexOf('move') >= 0 ? willPreventDefault : willNotPreventDefault;
                rootRef.addEventListener(key, _this.scrollHanders[key], pd);
            }
        });
    };
    Picker.prototype.componentWillUnmount = function () {
        var _this = this;
        Object.keys(this.scrollHanders).forEach(function (key) {
            if (key.indexOf('touch') === 0 || key.indexOf('mouse') === 0) {
                _this.rootRef.removeEventListener(key, _this.scrollHanders[key]);
            }
        });
    };
    Picker.prototype.passiveSupported = function () {
        return true;
    };
    Picker.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if ('selectedValue' in nextProps) {
            if (this.state.selectedValue !== nextProps.selectedValue) {
                this.setState({
                    selectedValue: nextProps.selectedValue,
                }, function () {
                    _this.props.select(nextProps.selectedValue, ITEM_HEIGHT, nextProps.noAnimate ? _this.scrollToWithoutAnimation : _this.scrollTo);
                });
            }
        }
        this.scrollHanders.setDisabled(nextProps.disabled);
    };
    Picker.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return this.state.selectedValue !== nextState.selectedValue
            || this.props.children !== nextProps.children;
    };
    Picker.prototype.componentDidUpdate = function () {
        this.props.select(this.state.selectedValue, ITEM_HEIGHT, this.scrollToWithoutAnimation);
    };
    Picker.prototype.getValue = function () {
        if ('selectedValue' in this.props) {
            return this.props.selectedValue;
        }
        var children = React.Children.toArray(this.props.children);
        return children && children[0] && children[0].props.value;
    };
    Picker.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.props, prefixCls = _b.prefixCls, itemStyle = _b.itemStyle, indicatorStyle = _b.indicatorStyle, _c = _b.indicatorClassName, indicatorClassName = _c === void 0 ? '' : _c, children = _b.children, type = _b.type, className = _b.className;
        var selectedValue = this.state.selectedValue;
        var map = function (item) {
            var _a;
            var _b = item.props, _c = _b.className, className = _c === void 0 ? '' : _c, style = _b.style, value = _b.value;
            var itemCls = classNames(prefixCls + "-item", className, (_a = {},
                _a[prefixCls + "-item-selected"] = selectedValue === value,
                _a));
            return (h("div", { style: __assign(__assign({}, itemStyle), style), className: itemCls, key: value }, item.children || item.props.children));
        };
        var items = React.Children ? React.Children.map(children, map) : [].concat(children).map(map);
        var pickerCls = classNames(prefixCls, className, (_a = {},
            _a[prefixCls + "-" + type] = type,
            _a));
        var indicatorCls = classNames(prefixCls + "-indicator", indicatorClassName);
        return (h("div", { className: pickerCls, ref: function (el) { _this.rootRef = el; }, style: this.props.style },
            h("div", { className: prefixCls + "-mask", ref: function (el) { _this.maskRef = el; } }),
            h("div", { className: prefixCls + "-content-container" },
                h("div", { className: prefixCls + "-content", ref: function (el) { _this.contentRef = el; } }, items),
                h("div", { className: prefixCls + "-content-placeholder" }, placeholderTextMap[type])),
            h("div", { className: indicatorCls, style: indicatorStyle }, indicatorTextMap[type])));
    };
    Picker.defaultProps = {
        prefixCls: 'rmc-picker',
    };
    return Picker;
}(React.Component));
export default PickerMixin(Picker);
